import { render, staticRenderFns } from "./Loadizer.vue?vue&type=template&id=7f06a082&scoped=true"
import script from "./Loadizer.vue?vue&type=script&lang=js"
export * from "./Loadizer.vue?vue&type=script&lang=js"
import style0 from "./Loadizer.vue?vue&type=style&index=0&id=7f06a082&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f06a082",
  null
  
)

export default component.exports